/**************************************************
 * Nombre:       Home_Espacios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Epacio from "../../Tarjetas/Tarjeta_Epacio";
import espacio from '../../../Recursos/espacio.png'


const Home_Espacios = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        {espacios.map((item, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Epacio item={item}/>
                                </Grid>
                            )
                        })}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Espacios

const espacios = [
    {
        img: espacio,
        nombreResaltado: 'La Logoterapia',
        nombre: 'una brújula para navegar momentos de incertidumbre',
        subtitulo: 'Dr Mauricio Nicolás Battafarano',
        fecha: 'Jueves, 30 de abril',
        hora: '6:00 pm Argentina',
        nombreCompleto: 'La Logoterapia una brújula para navegar momentos de incertidumbre'
    }
]